/*** IMPORTS FROM imports-loader ***/
(function() {

define([
	'jquery',
	'mustache',
	'pip-events',
	'window'
],
	function (
		$,
		Mustache,
		pipEvents,
		window
	) {

		var NO_DOORS_OR_WINDOWS = 'no doors or windows',
			NO_DOORS = 'no doors',
			NO_WINDOWS = 'no windows',
			ONE_DOOR = '1 door',
			ONE_WINDOW = '1 window',
			DOORS = ' doors',
			WINDOWS = ' windows',
			AVERAGE_DOOR_AREA = 21,
			AVERAGE_WINDOW_AREA = 12,
			SQUARE_FEET_PER_GALLON = 400;

		var view = {
			selectors: {
				calculateEstimate: {
					tab: '.calculator-estimator-container__tab',
					selectedTab: '.calculator-estimator-container__tab--selected',
					tabContent: '.tab-content',
					selectedTabContent: '.tab-content--selected',
					calculateButton: '.calculator-estimator-container .bttn__content',
					editMeasurementLink: '.measurement-link',
					estimateTab: '.estimate-tab',
					calculatorTab: '.calculator-tab',
					invalidForm: 'tab-content__form-section--invalid',
					invalidInput: 'form-input__field---invalid',
					dangerIcon: 'alert-inline--danger',
					calculate: {
						formSection: '.tab-content__form-section',
						formInput: '.paint-calculator .form-input__field',
						resultsSection: '.tab-content__results-section',
						resultsMessage: '#paint-calculator-results-message',
						height: '#paint-calculator__height',
						width: '#paint-calculator__width',
						length: '#paint-calculator__length',
						numberOfDoors: '#paint-calculator__number-of-doors',
						numberOfWindows: '#paint-calculator__number-of-windows',
						calculatorError: '.calculator-error'
					}
				}
			},
			templates: {
				modals: {
					calculateEstimate: $('#calculate-estimate').html(),
					calculator: {
						form: $('#paint-calculator-form-section').html(),
						results: $('#paint-calculator-results-section').html(),
						disclaimer: $('#paint-calculator-disclaimer').html(),
						estimate: $('#paint-calculator-estimate-section').html(),
					}
				},
			},
			render: {
				calculateEstimate: function calculateEstimate(data, partials) {
					return Mustache.render(view.templates.modals.calculateEstimate, data, {
						selectedPaintBanner: partials.selectedPaintBanner,
						modalHeader: partials.modalHeader,
						calculatorForm: view.templates.modals.calculator.form,
						disclaimer: view.templates.modals.calculator.disclaimer,
						estimatesSection: view.templates.modals.calculator.estimate
					});
				},
				calculatorForm: function calculatorForm() {
					return Mustache.render(
						view.templates.modals.calculator.form,
						{
							height: viewModel.calculator.form.height.value,
							width: viewModel.calculator.form.width.value,
							length: viewModel.calculator.form.length.value,
							numberOfDoors: viewModel.calculator.form.numberOfDoors.value,
							numberOfWindows: viewModel.calculator.form.numberOfWindows.value,
						},
						{ disclaimer: view.templates.modals.calculator.disclaimer }
					);
				},
				calculatorResults: function calculatorResults(data) {
					return Mustache.render(view.templates.modals.calculator.results, data, { disclaimer: view.templates.modals.calculator.disclaimer });
				},

				estimate: function estimate(data) {
					return Mustache.render(view.templates.modals.calculator.estimate, data);
				}
			},
			updateDOM: {
				calculatorForm: function updateCalculatorForm() {
					$(view.selectors.calculateEstimate.calculatorTab).html(view.render.calculatorForm());
				},
				calculatorResultsMessage: function updateCalculatorResultsMessage(results) {
					$(view.selectors.calculateEstimate.calculatorTab).html(view.render.calculatorResults(results));
				},
			},
			initDOMEventListeners: function initDOMEventListeners() {
				$(window.document).off('.calculate-estimate');
				$(window.document).on('click.calculate-estimate', view.selectors.calculateEstimate.tab, function () {

					var tab_id = '#' + $(this).attr('data-tab');
					$(view.selectors.calculateEstimate.tab).removeClass('u__bold calculator-estimator-container__tab--selected');
					$(view.selectors.calculateEstimate.tabContent).removeClass('tab-content--selected');
					$(this).addClass('u__bold calculator-estimator-container__tab--selected');
					$(tab_id).addClass('tab-content--selected');
				});

				$(window.document).on('click.calculate-estimate', view.selectors.calculateEstimate.calculateButton, function () {
					viewModel.calculator.calculateResults();
					//fire Calculate or Estimate event analytics
					pipEvents.ssku.calculateEstimate.trigger({
						component: 'Calculate or Estimate',
						target: view.selectors.calculateEstimate.calculateButton
					});
				});
				$(window.document).on('keyup.calculate-estimate', view.selectors.calculateEstimate.calculate.formInput, function () {
					viewModel.calculator.validateFields();
				});

				$(window.document).on('click.calculate-estimate', view.selectors.calculateEstimate.editMeasurementLink, function () {
					viewModel.calculator.isFormSubmitted = false;
					view.updateDOM.calculatorForm();
				});
			},
			init: function init() {
				view.initDOMEventListeners();
			}
		};

		var viewModel = {
			estimateData: { estimatesPerRoom: [] },
			colorData: {},
			loadWithTilesExpanded: false,
			calculator: {
				form: {
					height: {
						selector: view.selectors.calculateEstimate.calculate.height,
						minVal: 0,
						value: null,
						isValid: false,
						errorMessage: 'Height'
					},
					width: {
						selector: view.selectors.calculateEstimate.calculate.width,
						minVal: 0,
						value: null,
						isValid: false,
						errorMessage: 'Width'
					},
					length: {
						selector: view.selectors.calculateEstimate.calculate.length,
						minVal: 0,
						value: null,
						isValid: false,
						errorMessage: 'Length'
					},
					numberOfDoors: {
						selector: view.selectors.calculateEstimate.calculate.numberOfDoors,
						value: null,
						isValid: true
					},
					numberOfWindows: {
						selector: view.selectors.calculateEstimate.calculate.numberOfWindows,
						value: null,
						isValid: true
					},
				},
				isFormValid: true,
				isFormSubmitted: false,
				validateFields: function validateFields() {
					Object.keys(viewModel.calculator.form).forEach(function (key) {
						// Preserving input value
						viewModel.calculator.form[key].value = $(view.selectors.calculateEstimate.calculate[key]).val();

						viewModel.calculator.form[key].isValid = viewModel.calculator.form[key].hasOwnProperty('minVal')
							? viewModel.calculator.form[key].value > viewModel.calculator.form[key].minVal
							: true;

						if (!viewModel.calculator.form[key].isValid) {
							viewModel.calculator.isFormSubmitted && $(view.selectors.calculateEstimate.calculate[key]).parent().addClass(view.selectors.calculateEstimate.invalidInput + ' ' + view.selectors.calculateEstimate.dangerIcon);
						} else {
							$(view.selectors.calculateEstimate.calculate[key]).parent().removeClass(view.selectors.calculateEstimate.invalidInput + ' ' + view.selectors.calculateEstimate.dangerIcon);
						}
					});
				},
				validateForm: function validateForm() {
					viewModel.calculator.isFormValid = Object.keys(viewModel.calculator.form).every(function (key) {
						return viewModel.calculator.form[key].hasOwnProperty('minVal')
							? viewModel.calculator.form[key].isValid
							: true;
					});
					(!viewModel.calculator.isFormValid && viewModel.calculator.isFormSubmitted)
						&& $(view.selectors.calculateEstimate.calculate.formSection).addClass(view.selectors.calculateEstimate.invalidForm);
				},
				resetForm: function resetForm() {
					viewModel.calculator.isFormValid = false;
					$(view.selectors.calculateEstimate.calculate.formSection).removeClass(view.selectors.calculateEstimate.invalidForm);
					$(view.selectors.calculateEstimate.calculate.formInput).parent().removeClass(view.selectors.calculateEstimate.invalidInput + ' ' + view.selectors.calculateEstimate.dangerIcon);
				},
				setFormErrorMessage: function setFormErrorMessage() {
					var invalidItems = Object.keys(viewModel.calculator.form).map(function (key) {
						return !viewModel.calculator.form[key].isValid ? viewModel.calculator.form[key].errorMessage : ''
					}).filter(function (el) { return !!el; });
					var message;

					if (invalidItems.length > 2) {
						message = [
							invalidItems.slice(0, invalidItems.length - 1).join(', '),
							'and ' + invalidItems[invalidItems.length - 1]
						].join(', ');
					} else if (invalidItems.length == 2) {
						message = invalidItems.join(' and ');
					} else {
						message = invalidItems[0];
					}

					$(view.selectors.calculateEstimate.calculate.formSection)
						.find(view.selectors.calculateEstimate.calculate.calculatorError)
						.html(message ? 'Please enter a number for ' + message : '')
						.show();
				},
				getFormData: function getFormData() {
					return viewModel.calculator.form;
				},
				showResultsMessage: function showResultsMessage() {
					var form = viewModel.calculator.getFormData();
					return view.updateDOM.calculatorResultsMessage({
						gallonTotal: viewModel.calculator.getGallonMessage(
							form.height.value,
							form.width.value,
							form.length.value,
							form.numberOfDoors.value,
							form.numberOfWindows.value
						),
						message: viewModel.calculator.getWidthLengthResultsMessage(form.width.value, form.length.value) + viewModel.calculator.getDoorWindowMessage(form.numberOfDoors.value, form.numberOfWindows.value)
					});
				},
				calculateResults: function calculateResults() {
					viewModel.calculator.isFormSubmitted = true;
					viewModel.calculator.resetForm();
					viewModel.calculator.validateFields();
					viewModel.calculator.validateForm();

					if (viewModel.calculator.isFormValid) {
						$(view.selectors.calculateEstimate.calculate.formSection).find(view.selectors.calculateEstimate.calculate.calculatorError).hide();
						viewModel.calculator.showResultsMessage();
					}
					else {
						viewModel.calculator.setFormErrorMessage();
					}
				},
				getGallonMessage: function getGallonMessage(height, width, length, numberOfDoors, numberOfWindows) {
					var gallons = Math.ceil(((((length * 2) + (width * 2)) * height) - (AVERAGE_DOOR_AREA * numberOfDoors) - (AVERAGE_WINDOW_AREA * numberOfWindows)) / SQUARE_FEET_PER_GALLON);
					return gallons < 2 ? ' 1 Gallon' : gallons + ' Gallons';
				},
				getWidthLengthResultsMessage: function getWidthLengthResultsMessage(width, length) {
					return 'Based on one coat of paint for a '
						+ width + ' x ' + length + ' room with ';
				},
				getDoorWindowMessage: function getDoorWindowMessage(numberOfDoors, numberOfWindows) {
					if ((!numberOfDoors || (parseInt(numberOfDoors, 10) === 0)) && (!numberOfWindows || (parseInt(numberOfWindows, 10) === 0))) {
						return NO_DOORS_OR_WINDOWS;
					}
					return viewModel.calculator.getDoorMessage(numberOfDoors) + ' and ' + viewModel.calculator.getWindowMessage(numberOfWindows);
				},
				getDoorMessage: function getDoorMessage(numberOfDoors) {
					if (!numberOfDoors || (parseInt(numberOfDoors, 10) === 0)) {
						return NO_DOORS;
					}
					if (parseInt(numberOfDoors, 10) === 1) {
						return ONE_DOOR;
					}
					return numberOfDoors + DOORS;
				},
				getWindowMessage: function getWindowMessage(numberOfWindows) {
					if (!numberOfWindows || (parseInt(numberOfWindows, 10) === 0)) {
						return NO_WINDOWS;
					}
					if (parseInt(numberOfWindows, 10) === 1) {
						return ONE_WINDOW;
					}
					return numberOfWindows + WINDOWS;
				}
			}
		};

		return {
			init: function init() {
				view.init();
			},
			renderer: view.render.calculateEstimate,
			view: view,
			viewModel: viewModel
		}
	});

}.call(window));